import {Player, UserSource} from "@/store/player/types";
import {SuperPackPanel} from "@/scenes.ui/super-pack-panel";
import Image = Phaser.GameObjects.Image;
import Sprite = Phaser.GameObjects.Sprite;
import {SaleDetails, SaleOption} from "@/store/sale/types";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {BankOption} from "@/store/shop/types";
import Text = Phaser.GameObjects.Text;

export class SalePackPanel extends SuperPackPanel {

    private darkness: Image | undefined;
    private lock: Sprite | undefined;
    private innerBar!: Sprite;

    constructor(scene: Phaser.Scene, x: number, y: number, so: SaleOption, player: Player, userSource: UserSource,
                buyCallback: () => void, heroDescCallback: (heroId: string) => void, sd: SaleDetails, isReward: boolean = false,
                productPriceView: string | undefined = undefined) {
        super(scene, x, y, so, player, userSource, () => {
            if (TimeUtils.remainSec(sd.startAt) > 0) {
                new FeedbackPanel(scene, Tr('s.n.s'), undefined, true).show();
            } else {
                buyCallback();
            }
        }, heroDescCallback, isReward, productPriceView);

        let INNER_BAR_WIDTH: number = 293;

        let outerBar = SpriteUtils.addSprite(this.scene, this.getTitlePosX(), this.getBarPosY(so.decorationId), Keys.ATLAS_CHAIN, 'progr_out').setOrigin(0, 0);

        this.innerBar = SpriteUtils.addSprite(this.scene, this.getTitlePosX() + 4, this.getBarPosY(so.decorationId) + 2, Keys.ATLAS_CHAIN, 'progr_in')
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(this.innerBar, INNER_BAR_WIDTH * (so.countRemain / so.countTotal) * CU.S, 16 * CU.S);

        this.add([this.innerBar, outerBar]);

        let [prTxt, prCol] = SalePackPanel.getProgress(so);

        let progr = TextUtils.addTextAdvanced(this.scene, prTxt, outerBar.x / CU.S + INNER_BAR_WIDTH / 2, outerBar.y / CU.S + 11,
            prCol, 12, 'bold', 450, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);
        progr.setStroke('#505050', 3);
        this.add(progr);


        let oldPriceText = TextUtils.addTextAdvanced(scene, TextUtils.formatGems(so.oldPrice), 528, this.getBuyButtonPos(so.decorationId),
            '#ffffff', 13, 'normal', 200, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        oldPriceText.setShadow(0, 0, '#ffffff');
        oldPriceText.setStroke('#000000', 2);

        let underline = scene.add.line(0, 0,
            oldPriceText.getLeftCenter().x! + 16 * CU.S, oldPriceText.getLeftCenter().y!,
            oldPriceText.getRightCenter().x! + 14 * CU.S, oldPriceText.getRightCenter().y! + 14 * CU.S, 0xFF0000, 1);

        this.add([oldPriceText, underline]);


        let strip = SpriteUtils.addSprite(this.scene, 600, 30, Keys.ATLAS_BANK_2, 'strip').setOrigin(1, 0.5);
        this.add(strip);

        let discDesc = TextUtils.addTextAdvanced(this.scene, so.discountDesc, strip.x / CU.S - 80, strip.y / CU.S + 8,
            '#ffffff', 13, 'bold', 450, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);
        this.add(discDesc);

        if (TimeUtils.remainSec(sd.startAt) > 0) {
            this.lock = SpriteUtils.addSprite(this.scene, 500, this.getBuyButtonPos(so.decorationId) - 35, Keys.ATLAS_CHAIN, 'block')
                .setOrigin(0.5, 0.5);
            this.add(this.lock);
            this.disableTimer();
        }

        if (so.countRemain <= 0) {
            this.setRecieved(true, Tr('sold'));
            this.disableTimer();
            this.darkness = SpriteUtils.addImage(this.scene, 0, 0, Keys.CHAIN_DARK_GREY)
                .setSize(CU.CANVAS_WIDTH, this.getHeight(so.decorationId))
                .setOrigin(0, 0);
            this.add(this.darkness);
        }
    }

    private static getProgress(so: SaleOption): [string, string] {
        if (so.countRemain === so.countTotal) {
            return [Tr('qty') + String(so.countTotal), '#b4ffba'];
        } else if (so.countRemain === 1 && so.countTotal > 1) {
            return [Tr('lst') + String(so.countRemain) + '/' + String(so.countTotal) + ')', '#b4ffba'];
        } else if (so.countRemain > 0) {
            return [Tr('rst') + String(so.countRemain) + '/' + String(so.countTotal), '#b4ffba'];
        } else {
            return [Tr('sold') + ' (' + String(so.countRemain) + '/' + String(so.countTotal) + ')', '#bbbbbb'];
        }
    }

    protected getBarPosY(decorationId: string): number {
        if (decorationId === 'chain_6') {
            return 52;
        }
        return 59;
    }

    protected getTitlePosX(): number {
        return 140;
    }

    protected getDescPosX(bo: BankOption): number {
        return 143;
    }

    protected getDescPosY(bo: BankOption): number {
        return 78;
    }

    protected getDescWidth(bo: BankOption): number {
        return 270;
    }

    protected getStrokeColor(): string {
        return '#efefef';
    }

    protected setDescStroke(desc: Text) {
        desc.setStroke('#2a2a2a', 4);
    }
}
